export default (popupStepPath) => ({
  initExitIntentPopup() {
    if (this.store.values.exitIntent) return

    if (this.store.values.showDiscountModal) return

    window.addEventListener("mouseout", async (e) => {
      if (e.clientY < 0 && this.listenExitIntent) {
        if (this.store.values.token)
          return window.location.replace(`${popupStepPath}#stored-token=${this.store.values.token}`)

        window.location.replace(popupStepPath)
      }
    })
  },

  async closePopup() {
    this.store.values.showDiscountModal = false
    this.store.values.exitIntent = true
    await this.store.push()
    window.scrollTo(0, 0)
  },
})
